import { instance } from './index';

// CC 코스
//course list
function listCourse(withXml = false) {
  return instance.get('api/courses', { params: { withXml } });
}

// course detail
function detailCourse(id) {
  return instance.get(`api/courses/${id}`);
}

// course create
function createCourse(data) {
  return instance.post('api/courses', data);
}

// course modify
function updateCourse(id, data) {
  return instance.put(`api/courses/${id}`, data);
}

// CC 코스
//course list
function listCourseGroup() {
  return instance.get('api/courses/groups');
}

// course detail
function detailCourseGroup(id) {
  return instance.get(`api/courses/groups/${id}`);
}

// course create
function createCourseGroup(data) {
  return instance.post('api/courses/groups', data);
}

// course modify
function updateCourseGroup(id, data) {
  return instance.put(`api/courses/groups/${id}`, data);
}

export {
  listCourse,
  detailCourse,
  createCourse,
  updateCourse,
  listCourseGroup,
  detailCourseGroup,
  createCourseGroup,
  updateCourseGroup,
};
